var exports = {
  "kL": "x620889e6--dcb2b0--container",
  "tX": "x620889e6--dcb2b0--title-container",
  "Uo": "x620889e6--dcb2b0--buttons",
};

module.exports = exports;
